// @ts-strict-ignore
import {BehaviorEntity as Behavior, BehaviorsRequest, BehaviorsResultsMap} from 'app_api/projects/behaviors/types';
import {
  behaviorsClient,
  bulkUpdateBehaviors,
  createBehavior,
  deleteBehavior,
  updateBehavior,
} from 'common/report/queries/app-api/behaviors';
import {ApiResource} from 'common/util/model-resource/api-resource';

const CREATE_KEY = `create`;

export class BehaviorsResource extends ApiResource<Behavior> {
  apiClient = behaviorsClient;

  private async requestWrapper(loadingKeys: string[], callback: () => Promise<BehaviorsResultsMap>) {
    loadingKeys.forEach((key) => this.fetchesInProgress.set(key, undefined));
    this.notifySubscribers();
    try {
      const results = await callback();

      this.update(results, {partialUpdate: false});

      return results;
    } finally {
      loadingKeys.forEach((key) => this.fetchesInProgress.delete(key));
      this.notifySubscribers();
    }
  }

  patch(id: number, behavior: Partial<Behavior>): Promise<BehaviorsResultsMap> {
    const behaviorId = id.toString();
    return this.requestWrapper([behaviorId], () => updateBehavior({behaviorId, behavior}));
  }

  async bulkPatch(behaviors: Array<Partial<Behavior>>): Promise<BehaviorsResultsMap> {
    const behaviorIds = behaviors.map((b) => b.id?.toString() || ``);
    return this.requestWrapper(behaviorIds, () => bulkUpdateBehaviors(behaviors));
  }

  create(behavior: BehaviorsRequest): Promise<BehaviorsResultsMap> {
    return this.requestWrapper([CREATE_KEY], () => createBehavior(behavior));
  }

  async remove(behavior: Behavior): Promise<void> {
    await deleteBehavior(behavior);
    super.delete(behavior.id.toString());
  }

  isLoading(id?: number) {
    if (id) {
      return this.fetchesInProgress.has(id.toString());
    }
    return this.fetchesInProgress.has(CREATE_KEY);
  }
}
